import React from 'react';
import '../assets/styles/style.css';

export const Preloader = () => {
    return (
        <div className="preloader">
            <div className="geometric-background"></div>
            <div className="content-wrapper">
                <div className="loader-container">
                    <div className="particle-field"></div>
                    <div className="loader-ring-outer"></div>
                    <div className="loader-ring-middle"></div>
                    <div className="loader-ring-inner"></div>
                    <div className="loader-center">
                        <div className="center-circle"></div>
                        <div className="pulse-ring"></div>
                    </div>
                </div>
                <div className="text-container">
                    <div className="glitch-wrapper">
                        <h1 className="glitch-text" data-text="USHAN MIHIRANGA">
                            USHAN MIHIRANGA
                        </h1>
                    </div>
                    <div className="loading-line">
                        <div className="loading-progress"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};
